import React from 'react';
import { useTranslation } from 'react-i18next';
import './NewGuideStyled.scss';
import UnderConstruction from '../../component/ui/Common/UnderConstruction';

const GwMHAGuide = () => {
  const { t } = useTranslation();

  return (
    <div className="new-guide-page">
      <div className="page-title p-16">GWMHA</div>
      
      {/* 실제 페이지 콘텐츠 - 배경으로 보임 */}
      <div className="new-guide-content">
        <h2>GWMHA</h2>
        <p>{t('guide.mha.desc')}</p>
        
        {/* 더미 콘텐츠 */}
        <div className="new-stats-container">
          <div className="new-stat-card">
            <h3>{t('guide.mha.cardStatus')}</h3>
            <div className="new-stat-value">- / -</div>
          </div>
          <div className="new-stat-card">
            <h3>{t('guide.mha.cardReplication')}</h3>
            <div className="new-stat-value">- / -</div>
          </div>
          <div className="new-stat-card">
            <h3>{t('guide.mha.cardFailover')}</h3>
            <div className="new-stat-value">0</div>
          </div>
        </div>
      </div>
      
      {/* 공사중 표시 오버레이 */}
      <UnderConstruction />
    </div>
  );
};

export default GwMHAGuide;
